module.exports = __webpack_public_path__ + "static/img/19.044b855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/19.png
// module id = 4CtJ
// module chunks = 0